import { useEffect, useRef } from "react";

function ScrollTop() {
  const scrollToTopButton = useRef(null);

  useEffect(() => {
    const scrollFuction = () => {
      if (scrollToTopButton.current?.style) {
        if (
          document.body.scrollTop > 900 ||
          document.documentElement.scrollTop > 900
        ) {
          scrollToTopButton.current.style.visibility = "visible";
        } else {
          scrollToTopButton.current.style.visibility = "hidden";
        }
      }
    };

    window.addEventListener("scroll", scrollFuction);

    return () => {
      window.removeEventListener("scroll", scrollFuction);
    };
  }, []);

  const scrollToTop = () => {
    if (scrollToTopButton.current) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <i
      ref={scrollToTopButton}
      className="bx bxs-chevron-up"
      onClick={scrollToTop}
    ></i>
  );
}

export default ScrollTop;
